// https://ant.design/theme-editor

const theme = {
  token: {
    fontFamily:
      '"Nunito Sans", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    colorPrimary: "#1c1c1c",
    colorLink: "#209cee",
    colorSuccess: "#42bb6c",
    colorWarning: "#faad14",
    colorInfo: "#1890ff",
    colorError: "#d74945",
    borderRadius: 0,
    colorBgLayout: "#fff",
    colorBgContainer: "#fff",
  },
  components: {
    Form: {
      itemMarginBottom: 24,
      verticalLabelPaddingBottom: 8,
    },
    Layout: {
      headerBg: "#1c1c1c",
    },
    Modal: {
      bodyMargin: 0,
      paddingLG: 10,
      padding: 10,
    },
    Menu: {
      itemActiveBg: "#e8e8e8",
      itemSelectedBg: "#e8e8e8",
      itemSelectedColor: "#1c1c1c",
      itemHoverBg: "#e8e8e8",
      itemHoverColor: "#1c1c1c",
      itemColor: "#1c1c1c",
    },
    Table: {
      rowHoverBg: "#f5f5f5",
      headerBg: "white",
      cellPaddingBlock: 4,
      cellPaddingInline: 4,
      rowSelectedBg: "transparent",
      rowSelectedHoverBg: "#f5f5f5",
    },
    Button: {
      paddingInline: 15,
      paddingBlock: 4,
      paddingInlineSM: 4,
      boxShadow: "none",
      boxShadowSecondary: "none",
      primaryShadow: "none",
      colorBorder: "#d9d9d9",
      colorDanger: "#d74945",
    },
    Dropdown: {
      colorBgElevated: "#ffffff",
      activeShadow: "0 0 0 2px rgba(28, 28, 28, 0.2)",
      activeOutlineColor: "rgba(28, 28, 28, 0.2)",
      activeBorderColor: "#1c1c1c",
      padding: 0,
      paddingXS: 0,
      paddingXXS: 0,
    },
    Select: {
      optionSelectedBg: "#f5f5f5",
      activeShadow: "0 0 0 2px rgba(28, 28, 28, 0.2)",
      activeOutlineColor: "rgba(28, 28, 28, 0.2)",
      activeBorderColor: "#1c1c1c",
    },
    Segmented: {
      trackBg: "#f5f5f5",
    },
    Input: {
      activeShadow: "0 0 0 2px rgba(28, 28, 28, 0.2)",
    },
    InputNumber: {
      activeShadow: "0 0 0 2px rgba(28, 28, 28, 0.2)",
      activeBorderColor: "#1c1c1c",
      hoverBorderColor: "#1c1c1c",
    },
    DatePicker: {
      activeShadow: "0 0 0 2px rgba(28, 28, 28, 0.2)",
      activeBorderColor: "#1c1c1c",
      hoverBorderColor: "#1c1c1c",
    },
    Calendar: {
      itemActiveBg: "#f5f5f5",
      colorBgContainer: "#fff",
      colorText: "#1c1c1c",
    },
    Pagination: {
      margin: "5px 0px 0px 0px",
    },
    Notification: {
      motionDurationMid: "0.05s",
      motionDurationSlow: "0.05s",
    },
  },
};

export default theme;
